import React, { useEffect, useRef, useState } from 'react';
import { Link } from '@reach/router';
import { makeRequest } from 'js/services/Network';
import PubSub from 'pubsub-js';
import * as clipboard from 'clipboard-polyfill/text';
import AppUser from 'js/stores/AppUser';
import { Footer } from 'js/new/Components/PageSections';
import ProductDisplayUnique from 'js/components/pages/StatusPage/ItemStatusPage/BuyerReferral/ProductDisplayUnique';

const SellerLink = ({ current = 3 }) => {
  const [data, setData] = useState({});
  const [editName, setEditName] = useState(false);
  const [name, setName] = useState('');
  const editInput = useRef(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(async () => {
    const url = window.location.href;
    const urlParts = url.split('/');
    const alias = urlParts[urlParts.length - 1];

    if (false === AppUser.isLoggedIn) {
      window.location.href = '/';
    }

    const res = await makeRequest('seller-payment-link-data', { alias });
    setData(res.data);
    setName(res.data.storeName);
  }, []);

  const saveName = async () => {
    setSaving(true);

    makeRequest('update-login', null, { login: name })
      .then(response => {
        setError(null);
        setData(prevData => ({ ...prevData, storeName: name, storeUrl: response.data.store_url }));
        setSaving(false);
        setEditName(false);
      })
      .catch(error => {
        const message = error.response.data?.errors?.login[0];
        setError(message);
        setSaving(false);
      })
  }

  const copyText = (t) => {
    PubSub.publish('popup-text', 'Link copied!');
    clipboard.writeText(t).catch(() => { });
  };

  function truncate(str) {
    return str.length > 21 ? str.substring(0, 18) + "..." : str;
  }

  return (
    <div className='tw-bg-white seller-link-page new-pod-ui'>
      <div className='pod-container tw-p-6'>
        <h4>Hi {truncate(name)}, welcome to POD</h4>

        <div className="tw-my-8">
          <div className="tw-hidden md:tw-flex tw-items-center tw-gap-8">
            {[
              { n: 1, text: 'Create item' },
              { n: 2, text: 'Sign up' },
              { n: 3, text: 'Share checkout link' }
            ].map((step, i) => (
              <React.Fragment key={i}>
                <div className='tw-flex tw-gap-4 tw-items-center'>
                  <div className="from20-32 tw-flex tw-justify-center tw-rounded-full tw-items-center"
                    style={{ border: `1px ${step.n <= current ? '#6D60F6' : 'gray'} solid` }} >
                    <p style={{
                      fontWeight: step.n <= current ? 700 : 400,
                      color: step.n <= current ? '#6D60F6' : 'gray',
                      marginBottom: 0
                    }}>{step.n}</p>
                  </div>

                  <h5 className='tw-leading-relaxed' style={{
                    fontWeight: step.n <= current ? 700 : 400,
                    color: step.n <= current ? '#6D60F6' : 'gray',
                    marginBottom: 0
                  }}>
                    {step.text}
                  </h5>
                </div>
                {step.n !== 3 && <span className="tw-h-0 tw-flex-1" style={{ border: `1px ${step.n <= current ? '#6D60F6' : 'gray'} solid` }}></span>}
              </React.Fragment>
            ))}
          </div>

          <div className="md:tw-hidden tw-flex tw-gap-2 tw-justify-between">
            {[1, 2, 3].map((_, i) => (
              <div key={i} className={`tw-h-1.5 tw-flex-1 tw-rounded-full ${_ <= current ? 'tw-bg-secondary' : 'tw-bg-gray-400'}`}>
              </div>
            ))}
          </div>
        </div>

        <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-gap-4 tw-py-4">
          <div className="store-container">
            <div className="store-name d-flex align-items-center justify-content-between">
              {editName ? (
                <input type="text" value={name} ref={editInput} className="me-2" onChange={(e) => setName(e.target.value)} />
              ) : (
                <h2>Shop {truncate(name) ?? 'Loading...'}</h2>
              )}

              {editName ? (
                <>
                  <button
                    className='btn btn-pod btn-secondary outline d-flex justify-content-between align-items-center'
                    onClick={() => setEditName(!editName)}
                    disabled={saving}
                  >
                    Cancel
                  </button>
                  <button
                    className='btn btn-pod btn-light-purple outline d-flex justify-content-between align-items-center'
                    onClick={saveName}
                    disabled={saving}
                  >
                    Save
                  </button>
                </>
              ) : ('')}
            </div>

            {error && <div className='error-message'>{error}</div>}

            <div className='tw-mt-10'>
              <h6>Congratulations! 🎉</h6>
              <p>{data.item_count > 1 ? 'Your item has been added.' : 'Your store has been created.'} Share your store link with your customers and on your social media.</p>
            </div>

            <div className="store-link">
              Store link: <div className='tw-text-primary'>{data?.storeUrl}</div>
            </div>

            <button
              className="copy-button btn btn-pod btn-secondary mt-3 d-flex align-items-center justify-content-center"
              onClick={() => copyText(data?.storeUrl)}
              disabled={!data}
            >
              <img src="/images/icons/copy.svg" alt="Copy store link" className="me-2" />
              Copy store link
            </button>

            <div className="tw-flex tw-items-center tw-gap-4">
              <hr style={{ borderTop: '2px solid gray' }} className='tw-flex-1' />
              <p className='tw-font-semibold'> Now share your store on social media </p>
              <hr style={{ borderTop: '2px solid gray' }} className='tw-flex-1' />
            </div>

            <div className="social-icons mt-5">
              <ul className="m-0 d-flex justify-content-center align-items-center">
                {[
                  { src: "/images/icons/facebook.svg", alt: "Facebook" },
                  { src: "/images/icons/x.svg", alt: "X" },
                  { src: "/images/icons/whatsapp.svg", alt: "Whatsapp" },
                  { src: "/images/icons/instagram.svg", alt: "Instagram" },
                  { src: "/images/icons/tiktok.svg", alt: "TikTok" }
                ].map((icon, index) => (
                  <li key={index}>
                    <img src={icon.src} alt={icon.alt} />
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="blue-container tw-py-4 md:tw-py-0">
            <h5 className='tw-font-bold'>{data.item_count > 1 ? 'Yay! Your item was added successfully' : 'Yay! You have added your first item'}</h5>
            <p>
              You have taken the first giant and most important step.
              Add more items to your catalog to enable your customers purchase one or more items from your store.
            </p>

            <div className='tw-flex tw-items-center tw-justify-between tw-py-4'>
              <ProductDisplayUnique image={data?.image || ''} title={data?.title ?? 'Loading...'} price={data?.price ?? 0} />

              <a href={data?.manageUrl ?? '#'} className="d-flex align-items-center">
                <img src="/images/icons/edit-2.svg" alt="Edit item" />
                Edit Item
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <div className="seller-bottom-button tw-grid md:tw-hidden">
        <Link to={'/create-link'} className="btn btn-pod btn-secondary">
          Start selling safely
        </Link>
      </div>
    </div>
  )
}

export default SellerLink;
